import { MIDDLEWARE } from 'enums/middleware'

const isMiddlewareSkipped = (app, route) =>
  app.$helper.isMiddlewareSkipped(MIDDLEWARE.PAGE_SEO, route)

export default async function({ app, store, route, redirect }) {
  if (isMiddlewareSkipped(app, route)) return

  try {
    const requestPageSeoFn = () => {
      return store.dispatch('seo/requestPageSeo', {
        routeName: route.name
      })
    }

    await requestPageSeoFn()
  } catch (err) {
    redirect()
  }
}
